import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', loadChildren: './home/home.module#HomePageModule' },
  { path: 'login', loadChildren: './pages/login/login.module#LoginPageModule' },
  { path: 'register', loadChildren: './pages/register/register.module#RegisterPageModule' },
  { path: 'forgotpassword', loadChildren: './pages/forgotpassword/forgotpassword.module#ForgotpasswordPageModule' },
  { path: 'resetpassword', loadChildren: './pages/resetpassword/resetpassword.module#ResetpasswordPageModule' },
  { path: 'dashboard', loadChildren: './pages/dashboard/dashboard.module#DashboardPageModule' },
  { path: 'places', loadChildren: './pages/places/places.module#PlacesPageModule' },  { path: 'singleplace', loadChildren: './pages/singleplace/singleplace.module#SingleplacePageModule' },
  { path: 'notifications', loadChildren: './pages/notifications/notifications.module#NotificationsPageModule' },
  { path: 'profile', loadChildren: './pages/profile/profile.module#ProfilePageModule' },
  { path: 'saved', loadChildren: './pages/saved/saved.module#SavedPageModule' },
  { path: 'destinations', loadChildren: './pages/destinations/destinations.module#DestinationsPageModule' },
  { path: 'restaurants', loadChildren: './pages/restaurants/restaurants.module#RestaurantsPageModule' },
  { path: 'hotels', loadChildren: './pages/hotels/hotels.module#HotelsPageModule' },
  { path: 'singlehotel', loadChildren: './pages/singlehotel/singlehotel.module#SinglehotelPageModule' },
  { path: 'flights', loadChildren: './pages/flights/flights.module#FlightsPageModule' },






];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
